<template>

    <teleport to="#modal">
        <Loading
            :visible="pianoDiFatturazione.loading"
        >
        </Loading>
    </teleport>

    <ModalPianoFatturazione
        v-model:visible="modal_visible"
        :contatoriIva="ContatoriIva"
        @save="onSave"
        :sottoprogetto_id="id"
        :errors="errors"
        :row_model=row_model
        :versione="versione"
    ></ModalPianoFatturazione>

    <Modal v-model:visible="modal_contratto_visible" :backdrop="true">
        <template v-slot:header>
            <div>
                <h2 class="text-lg font-bold mb-3">Dati contrattuali</h2>
            </div>
        </template>
        <template v-slot:main>
            <div class="flex flex-col mb-3 gap-3">
                <div class="flex flex-col">
                    <Field v-model="numero_contratto_model"
                           field_name="Numero contratto"
                           placeholder="N contratto"
                           :errors="getErrorsContratto('pdf_numero_contratto')"
                    ></Field>
                </div>

                <div class="flex flex-col">
                    <Field v-model="data_contratto_model"
                           field_name="Data contratto"
                           type="date"
                           placeholder="Data contratto"
                           :errors="getErrorsContratto('pdf_data_contratto')"
                    ></Field>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end pt-3">
                <NextButton variant="outline-secondary"
                            @click="modal_contratto_visible=false"
                            class="col-start-3 py-2 px-4">
                    Chiudi
                </NextButton>
                <NextButton variant="primary"
                            @click="onSaveDatiContrattuali"
                            class="ml-4 py-2 px-4">
                    Salva
                </NextButton>
            </div>
        </template>
    </Modal>

    <Modal v-model:visible="modal_stato_visible" :backdrop="true">
        <template v-slot:header>
        </template>
        <template v-slot:main>
            <div class="flex flex-col mb-3 gap-3">
                <Field v-model="numero_contratto_model"
                       field_name="Stato"
                       :errors="getErrorsStato('stato')"
                >
                    <VueMultiselect
                        v-model="stato_model"
                        :options="statoPianificazioneAutocomplete.options"
                        :loading="statoPianificazioneAutocomplete.isLoading"
                        @search-change="statoPianificazioneAutocomplete.search"
                        class="next-vue-multiselect-single"
                        :close-on-select="true" :clear-on-select="false"
                        deselectLabel="Deseleziona"
                        selectedLabel="Selezionato"
                        selectLabel="Seleziona"
                        track-by="id"
                        label="text"
                    >
                    </VueMultiselect>
                </Field>
                <Field v-if="stato_model.id == 2" :labelVisible="false" :errors="getErrorsStato('allegato')">
                    <FileUpload
                        v-model:uploaded_files="uploaded_files"
                        v-model:model_files="model_files"
                        v-model:to_delete="to_delete"
                        accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                    >
                        <template v-slot:default="{props, methods}">
                            <div class="flex flex-col grow">
                                <NextButton variant="outline-secondary" @click="methods.open"
                                            class="w-full h-10 px-4 grow">
                                    <i class="icon icon-graffetta"></i> Allega
                                </NextButton>
                                <div v-if="props.to_upload" class="grid grid-cols-1 gap-3">
                                    <a class="underline text-sm text-next-atp pt-3"
                                       v-for="(f,idx) in props.to_upload" :key="idx">
                                        <span>{{ f.name }}</span>
                                    </a>
                                </div>
                                <div v-if="uploaded_files" class="grid grid-cols-1 gap-3">
                                    <a class="underline text-sm text-next-atp pt-3 cursor-pointer"
                                       @click="downloadFile(f?.id)"
                                       target="_blank"
                                       v-for="(f,idx) in uploaded_files" :key="idx">
                                        <span>{{ f.name }}</span>

                                    </a>
                                </div>
                            </div>
                        </template>
                    </FileUpload>
                </Field>
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end pt-3">
                <NextButton variant="outline-secondary"
                            @click="modal_stato_visible=false"
                            class="col-start-3 py-2 px-4">
                    Chiudi
                </NextButton>
                <NextButton variant="primary"
                            @click="setStato"
                            class="ml-4 py-2 px-4">
                    Salva
                </NextButton>
            </div>
        </template>
    </Modal>

    <div id="selectModal"></div>

    <div class="m-auto px-8 md:px-20 pb-8">
        <div v-show="!StessaValutaVendita" class="pt-3">
            <Alert>Gli ordini di vendita hanno valute differenti</Alert>
        </div>
        <div class="py-10 flex justify-between">
            <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
            <div class="flex gap-3">
                <BadgeStato :stato="stato_gamma?.PD0C_STATO_PD1E" class="whitespace-nowrap flex items-center"></BadgeStato>

                <VueMultiselect
                    v-model="versione"
                    :options="versioni"
                    class="next-vue-multiselect-single w-80"
                    deselectLabel=""
                    selectedLabel=""
                    selectLabel=""
                    label="version"
                >
                    <template v-slot:option="{option, props}">
                        Versione {{ option?.version }} del {{ $filters.toDate(option?.created_at) }} alle
                        {{ $filters.toTime(option?.created_at) }}
                    </template>
                    <template v-slot:singleLabel="{option, props}">
                        Versione {{ option?.version }} del {{ $filters.toDate(option?.created_at) }} alle
                        {{ $filters.toTime(option?.created_at) }}
                    </template>
                </VueMultiselect>


<!--                <div class="bg-next-gray-md-dark text-sm py-1 px-2 flex items-center">-->
<!--                    Versione {{ Sottoprogetto?.last_major }}.{{ Sottoprogetto?.last_minor }} del-->
<!--                    {{ $filters.toDate(Sottoprogetto?.updated_at) }} alle-->
<!--                    {{ $filters.toTime(Sottoprogetto?.updated_at) }}-->
<!--                </div>-->
            </div>
        </div>

        <div class="m-auto">
            <Alert v-if="error_message" :dismissable="true" @close="error_message = ''"
                   class="bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50">
                {{ error_message }}
            </Alert>
            <!--            <div class="flex justify-between mb-3">-->
            <!--                <h1 class="text-2xl font-bold mb-2">-->
            <!--                    Cliente: {{ cliente?.denominazione }}-->
            <!--                </h1>-->
            <!--                <NextButton @click="salva" variant="primary" class="px-3 py-2">Salva</NextButton>-->

            <!--            </div>-->
            <div class="flex justify-between items-end mb-3">
                <h2 class="text-xl font-bold">Sottoprogetto: {{ Sottoprogetto?.titolo }}</h2>
                <div class="text-sm">ID progetto: {{ progetto?.id_gamma }} / Codice commessa: {{
                        Sottoprogetto?.cod_nodo
                    }}
                </div>
            </div>

            <div class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 overflow-x-auto mb-5">
                <CardDivisorioGrigio>
                    <template #top>
                        <div class="text-sm"><b>Budget di progetto</b></div>
                    </template>
                    <template #bottom>
                        {{ NonConforme ? '---' : RicaviValuta.toCurrencyString() }} {{ valutaLabel }} <span
                        v-show="Valuta">&nbsp;/ {{ Ricavi.toCurrencyString() }} €</span>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template #top>
                        <div class="text-sm"><b>Pianificato</b></div>
                    </template>
                    <template #bottom>
                        {{ Pianificato.toCurrencyString() }} {{ valutaLabel }} <span
                        v-show="Valuta">&nbsp;/ {{ PianificatoEuro.toCurrencyString() }} €</span>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template #top>
                        <div class="text-sm"><b>Residuo</b></div>
                    </template>
                    <template #bottom>
                        {{ NonConforme ? '---' : Residuo.toCurrencyString() }} {{ valutaLabel }} <span v-show="Valuta">&nbsp;/ {{
                            ResiduoEuro.toCurrencyString()
                        }} €</span>
                    </template>
                </CardDivisorioGrigio>

                <CardDivisorioGrigio class="col-span-2">
                    <template #top>
                        <div class="text-sm"><b>Contatori per iva</b></div>
                    </template>
                    <template #bottom>
                        <div class="grid grid-cols-4 w-full">
                            <p class="font-bold">IVA</p>
                            <p class="font-bold">Totale</p>
                            <p class="font-bold">Pianificato</p>
                            <p class="font-bold">Residuo</p>
                            <template v-for="(v,i) in ContatoriIva">
                                <p>{{ v.descrizione }}</p>
                                <p>{{ $filters.toCurrency(v.totale_ricavi) }}</p>
                                <p>{{ $filters.toCurrency(v.pianificato) }}</p>
                                <p>{{ $filters.toCurrency(v.totale_ricavi - v.pianificato) }}</p>
                            </template>
                        </div>
                    </template>
                </CardDivisorioGrigio>

                <CardDivisorioGrigio class="col-start-6">
                    <template #top>
                        <div class="text-sm font-bold">Data: {{ $filters.toDate(data_contratto) }} - Numero:
                            {{ numero_contratto || '---' }}
                        </div>
                    </template>
                    <template #bottom>
                        <div class="flex w-full justify-end">
                            <NextButton variant="primary"
                                        @click="modal_contratto_visible = true"
                                        class="py-2 px-4">
                                Dati contratto
                            </NextButton>
                        </div>
                    </template>
                </CardDivisorioGrigio>

            </div>

            <div class="flex justify-end mb-3">
                <NextButton variant="primary" @click="addOdv" class="px-3 py-2">Aggiungi riga di pianificazione
                </NextButton>
            </div>


            <div class="flex justify-end">
                <Paginator class="" :pagination="pianoDiFatturazione.paginate"></Paginator>
            </div>

            <div class="rotate-x-180 overflow-x-scroll">

                <NextTable class="rotate-x-180 table-fixed w-full border-separate border-spacing-1 py-4"
                           v-model:cols="righeCols"
                           :rows="pianoDiFatturazione.rows" @order-update="pianoDiFatturazione.updateCols">
                    <template v-for="(c, j) in pianoDiFatturazione.rows" :key="j" v-slot:[`td_${j}_2`]>
                        {{ $filters.toDate(c.data_emissione_fattura) }}
                    </template>

                    <template v-for="(c, j) in pianoDiFatturazione.rows" :key="j" v-slot:[`td_${j}_3`]>
                        {{ $filters.toCurrency(PercentualeRighePianoDiFatturazione(c.righe)) }} %
                        <!--                        { $filters.toCurrency(c.valore / RicaviValuta * 100) }} %-->
                    </template>

                    <template v-for="(c, j) in pianoDiFatturazione.rows" :key="j" v-slot:[`td_${j}_4`]>
                        {{ $filters.toCurrency(TotaleRighePianoDiFatturazione(c.righe)) }}
                    </template>

                    <template v-for="(c, j) in pianoDiFatturazione.rows" :key="j" v-slot:[`td_${j}_10`]="{context}">
                        <div class="grow self-center"
                             @click="initModalStato(c)">
                            {{
                                statoPianificazioneManager.stati.find(el => el.id == context.row[context.cell.prop])?.text
                            }}
                            <a v-if="context.row?.allegato_file_id" @click.stop=""
                               class="block underline text-sm text-next-atp whitespace-nowrap cursor-pointer"
                               @click="downloadFile(context.row?.allegato_file_id)">
                                Scarica allegato
                            </a>
                        </div>
                        <!--                        <DynamicCell-->
                        <!--                            :modelValue="statoPianificazioneManager.stati.find(el=> el.id == context.row[context.cell.prop])"-->
                        <!--                            :is_component="getComponent()"-->
                        <!--                            v-bind="{inputClass: 'bg-transparent cursor-pointer'}"-->
                        <!--                            @confirm="setStato($event, c)"-->
                        <!--                            :autocomplete="statoPianificazioneAutocomplete"-->
                        <!--                            class="next-vue-multiselect-single"-->
                        <!--                            placeholder="Stato pianificazione"-->
                        <!--                            titolo="Stato"-->
                        <!--                            track-by="id"-->
                        <!--                            label="text"-->
                        <!--                        >-->
                        <!--                            <template v-slot:text="{value}">{{ value }}</template>-->
                        <!--                        </DynamicCell>-->
                    </template>

                    <template v-for="(c, j) in pianoDiFatturazione.rows" :key="j" v-slot:[`td_${j}_0`]="context">
                        <TabellaContextMenu
                            menuClass="shadow absolute flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                            buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                            :context="c"
                            :id="j"
                            teleport_to="#modal"
                            :cmOpener="cmOpener"
                        >
                            <span @click="duplicaRiga(c)" class="w-full hover:text-next-neu mb-2">Duplica</span>
                            <span @click="modificaRiga(c)" class="w-full hover:text-next-neu mb-2">Modifica</span>
                            <ConfirmDelete position="right"
                                           @cancella="cancellaRiga(c)">
                                <span class="cursor-pointer hover:text-next-neu">Elimina</span>
                            </ConfirmDelete>
                        </TabellaContextMenu>
                    </template>
                    <template v-for="(c, j) in pianoDiFatturazione.rows" :key="j" v-slot:[`td_child_${j}`]="{context}">
                        <tr v-for="(cc, i) in context.row.righe" :key="i" class="h-5 text-sm">
                            <td></td>
                            <td colspan="3" class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                {{ cc.iva.descrizione }}
                            </td>
                            <td class="px-2 bg-transparent text-right border-b-2 border-b-next-gray-md-dark">
                                {{ $filters.toEuroCurrency(Number(cc.valore)) }}
                            </td>
                            <td colspan="7" class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                {{ cc.note }}
                            </td>
                        </tr>

                    </template>
                </NextTable>

            </div>
            <InfiniteLoading @infinite="pianoDiFatturazione.fetchNextPage"
                             :identifier="pianoDiFatturazione.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre righe.</div>
                </template>
            </InfiniteLoading>


            <!--            <div class="flex justify-end">-->
            <!--                <NextButton variant="primary" @click="print" class="px-3 py-2">debug-->
            <!--                </NextButton>-->
            <!--            </div>-->

        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import {mapActions, mapGetters, mapState} from 'vuex';
import NextTable from "@/components/NextTable.vue";
import sottoProgettiManager from "../api/SottoProgetti";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import progettiManager from "../api/Progetti";
import clientiManager from "../api/Clienti";
import CardDivisorioGrigio from "@/components/CardDivisorioGrigio.vue";
import BadgeStato from "@/components/BadgeStato.vue";
import NextButton from "@/components/NextButton.vue";
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import Alert from "@/components/Alert.vue";
import sottoprogettoPianoDiFatturazioneManager from "../api/SottoprogettoPianoDiFatturazione";
import Lista from "@/setup/ListaCerca";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import InfiniteLoading from "v3-infinite-loading";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import ContextMenu from "@/components/ContextMenu.vue";
import DynamicCell from "@/components/DynamicCell.vue";
import Select from "@/components/Select.vue";
import Autocomplete from "@/setup/Autocomplete";
import statoPianificazioneManager from "../api/StatoPianificazioneManager";
import ModalInput from '@/components/ModalInput.vue';
import Field from "@/components/Field.vue";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";
import Modal from "@/components/Modal.vue";
import FileUpload from "@/components/FileUpload.vue";
import ModalPianoFatturazione from "@/components/ModalPianoFatturazione.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "@/components/Loading.vue";
import ModalProjectFilter from "@/components/ModalProjectFilter.vue";


@Options({
    name: 'SottoProgettoPianoFatturazione',
    components: {
        ModalProjectFilter,
        Loading,
        Paginator,
        ModalPianoFatturazione,
        FileUpload,
        Modal,
        Field,
        Select,
        DynamicCell,
        ContextMenu,
        TabellaContextMenu,
        InfiniteLoading,
        Alert,
        ConfirmDelete,
        NextButton,
        BadgeStato,
        CardDivisorioGrigio,
        Breadcrumbs,
        NextTable,
    },
    inject: ['downloadFile'],
    props: {
        id: String,
    },
    computed: {
        ...mapState('buFieldModule', {
            sottoProgettiCols: (state: any) => state.sottoProgettiCols
        }),
        ...mapGetters('sprjDataManager', [
            "ActiveTab",
            "AliquoteVendita",
            "RecordSfusiAcquisto",
            "SelectedRows",
            "TotalizzatoriIva",
            "RecordPerIvaAcquisto",
            "Sottoprogetto",
            "getValuta",
            'AcCostoUnitarioNetto',
            'AcCostoTotale',
            'VeBudget',
            'BudgetLordoIva',
            'Utile',
            'CostoVenditaUnitario',
            'Mol',
            'TotaleBudgetProgetto',
            'VeBudget',
            'TotaleMol',
            "StessaValutaVendita",
            "GetFirstValutaVendita"
        ])
    },
    methods: {
        ...mapActions('sprjDataManager', [
            'setSottoprogetto',
            'setDatiSottoprogetto',
            "retrieveData",
            'setValute'

        ]),
    }
})
export default class SottoProgettoPianoFatturazione extends Vue {
    Sottoprogetto!: any
    getValuta!: any
    ActiveTab!: any
    StessaValutaVendita!: any
    GetFirstValutaVendita!: any
    TotalizzatoriIva!: any
    TotaleBudgetProgetto!: any
    VeBudget!: any
    setValute: any;
    setSottoprogetto: any;
    setDatiSottoprogetto: any;
    errors = {};
    errors_contratto = {};
    errors_stato = {};
    uploaded_files: any = []
    model_files = []
    to_delete = []

    statoPianificazioneManager = statoPianificazioneManager

    statoPianificazioneAutocomplete: any = setup(() => Autocomplete(statoPianificazioneManager))

    id!: number | string
    loading = false
    modal_visible = false
    modal_contratto_visible = false
    modal_stato_visible = false
    stato_gamma = null
    versione = {id:0}
    versioni = []

    row_model: any = {}
    default_cliente_id = null
    default_termine_pagamento_id = null
    error_message = ''

    progetto: any = {}
    cliente: any = {}

    data_contratto: string = ''
    numero_contratto: string = ''
    data_contratto_model: string = ''
    numero_contratto_model: string = ''

    stato_model: any = null
    allegato_model: any = null
    stato_editing_row: any = null
    edit_row_id = 0

    getErrorsContratto(field: string) {
        return (this.errors_contratto as any)[field]
    }

    getErrorsStato(field: string) {
        return (this.errors_stato as any)[field]
    }

    TotaleRighePianoDiFatturazione(righe: any[]) {
        return righe.reduce((val, row: any) => {
            return val + Number(row.valore)
        }, 0)
    }

    PercentualeRighePianoDiFatturazione(righe: any[]) {
        const totale_riga = this.TotaleRighePianoDiFatturazione(righe)
        return totale_riga / this.Ricavi * 100
    }

    initModalStato(c: any) {
        this.stato_editing_row = c
        this.stato_model = statoPianificazioneManager.stati.find(el => el.id == c.conferma)
        this.modal_stato_visible = true
    }

    setStato() {
        sottoprogettoPianoDiFatturazioneManager.cambiaStatoPianoDiFatturazione(this.id, this.stato_editing_row.id, {
            stato: this.stato_model.id,
            allegato: this.uploaded_files[0]?.id || null
        }).then(() => {
            this.reset_model()
            this.pianoDiFatturazione.reset()
            this.modal_stato_visible = false
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors_stato = res.response.data.errors
            }
        })
    }

    pianoDiFatturazione: any = setup(() => Lista(sottoprogettoPianoDiFatturazioneManager, this.righeCols, sottoProgettiManager.pianoDiFatturazione))
    cmOpener: any = setup(() => ContextMenuOpener('top-left'))

    get LastVersion(){
        return this.pianoDiFatturazione.rows.filter((r:any)=>{
            return r.versione == this.Sottoprogetto?.version
        })
    }

    get Pianificato() {
        return this.LastVersion.reduce((val: number, el: any) => {
            return val + el.righe.reduce((val: number, el: any) => {
                return val + Number(el.valore)
            }, 0)
        }, 0)
    }

    get PianificatoEuro() {
        if (this.Valuta) {
            return this.Pianificato * this.Valuta.valore
        }
        return this.Pianificato
    }

    get Residuo() {
        return this.RicaviValuta - this.Pianificato
    }

    get ResiduoEuro() {
        return this.Ricavi - this.PianificatoEuro
    }

    get Ricavi() {
        if (this.ActiveTab && this.TotaleBudgetProgetto(this.ActiveTab.sezioni)) {
            return this.TotaleBudgetProgetto(this.ActiveTab.sezioni)
        }
        return 0;
    }

    get RicaviValuta() {
        if (this.Valuta) {
            return this.Ricavi / this.Valuta?.valore
        }
        return this.Ricavi
    }

    addOdv() {
        this.row_model.cliente_id = this.default_cliente_id
        this.row_model.termine_pagamento_id = this.default_termine_pagamento_id
        this.row_model.data_emissione_fattura = ''
        this.row_model.po = ''
        this.row_model.bef = ''
        this.row_model.note = ''
        this.row_model.righe = []
        this.modal_visible = true;
    }

    get valutaLabel() {
        return this.Valuta?.valuta?.CG08_SIGLA || '€'
    }

    get Valuta() {
        if (!this.StessaValutaVendita) {
            return undefined
        }
        return this.getValuta(this.GetFirstValutaVendita)
    }

    get NonConforme() {
        return !this.StessaValutaVendita
    }

    onSaveDatiContrattuali() {
        sottoProgettiManager.contratto(this.id, {
            pdf_numero_contratto: this.numero_contratto_model,
            pdf_data_contratto: this.data_contratto_model,
        }).then(() => {
            this.numero_contratto = this.numero_contratto_model
            this.data_contratto = this.data_contratto_model
            this.modal_contratto_visible = false
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors_contratto = res.response.data.errors
            }
        })
    }

    validateMaxValues($event: any) {
        if ($event && $event.righe) {
            for (let i = 0; i < $event.righe.length; i++) {
                let row = $event.righe[i]
                for (let j in this.ContatoriIva) {
                    if (j == row.iva_id) {
                        let iva = this.ContatoriIva[j]
                        let totale_pianificato = iva.pianificato + Number(row.valore)
                        if (totale_pianificato > iva.totale_ricavi) {
                            //@ts-ignore
                            this.errors[`righe.${i}.valore`] = ['Il valore supera il totale per l\'iva selezionata']
                            return false
                        }
                    }
                }
            }
        }
        return true
    }

    @Watch('modal_visible')
    handleCloseModal(new_value: any, old: any) {
        if (!new_value) {
            this.edit_row_id = 0
            this.reset_model()
        }
    }

    onSave($event: any) {
        if (!this.validateMaxValues($event)) {
            return
        }
        if (this.edit_row_id) {
            return sottoprogettoPianoDiFatturazioneManager.updatePianoDiFatturazione(
                this.id,
                this.row_model.id,
                {
                    descrizione: $event.descrizione,
                    data_emissione_fattura: $event.data_emissione_fattura,
                    po: $event.po,
                    bef: $event.bef,
                    cliente_id: $event.cliente_id,
                    note: $event.note,
                    termine_pagamento_id: $event.termine_pagamento_id,
                    righe: $event.righe
                }
            ).then(() => {
                this.pianoDiFatturazione.reset()
                this.modal_visible = false;
                this.edit_row_id = 0
            }).catch((res: any) => {
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        } else {
            //@ts-ignore
            return sottoprogettoPianoDiFatturazioneManager.createPianoDiFatturazione(
                this.id,
                {
                    versione_id: this.versione.id,
                    descrizione: $event.descrizione,
                    data_emissione_fattura: $event.data_emissione_fattura,
                    po: $event.po,
                    bef: $event.bef,
                    cliente_id: $event.cliente_id,
                    note: $event.note,
                    termine_pagamento_id: $event.termine_pagamento_id,
                    righe: $event.righe
                }
            ).then(() => {
                this.pianoDiFatturazione.reset()
                this.modal_visible = false;
                this.edit_row_id = 0
            }).catch((res: any) => {
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        }
    }

    get ContatoriIva() {
        const ret:any = {}
        for (let i in this.TotalizzatoriIva) {
            ret[i] = {...this.TotalizzatoriIva[i], 'pianificato': 0}
        }
        this.LastVersion.filter((row: any) => {
            return this.edit_row_id != row.id
        }).forEach((row: any) => {
            row.righe.forEach((row_iva: any) => {
                if (ret[row_iva.iva_id]) {
                    ret[row_iva.iva_id]['pianificato'] += Number(row_iva.valore)
                }
            })
        })
        return ret;
    }

    cancellaRiga(row: any) {
        sottoprogettoPianoDiFatturazioneManager.deletePianoDiFatturazione(this.id, row.id).then(this.pianoDiFatturazione.reset)
        this.cmOpener.close()
    }

    duplicaRiga(row: any) {
        this.edit_row_id = 0
        this.onSave({
            descrizione: row.descrizione,
            cliente_id: row.cliente_id,
            data_emissione_fattura: row.data_emissione_fattura,
            termine_pagamento_id: row.termine_pagamento_id,
            po: row.po,
            bef: row.bef,
            note: row.note,

            righe: row.righe.map((iva: any) => {
                return {iva_id: iva.iva.id, valore: iva.valore}
            })
        })
    }

    modificaRiga(row: any) {
        this.edit_row_id = row?.id
        // devo copiare i valori altrimeni riferisco i campi dell'oggetto
        this.row_model = JSON.parse(JSON.stringify(row))
        this.modal_visible = true;
    }

    reset_model() {
        this.row_model.cliente_id = this.default_cliente_id
        this.row_model.termine_pagamento_id = this.default_termine_pagamento_id
        this.row_model.id = null
        this.row_model.descrizione = null
        this.row_model.valore = null
        this.row_model.data_emissione_fattura = null
        this.row_model.termine_pagamento = null
        this.row_model.po = null
        this.row_model.bef = null
        this.row_model.conferma = null
        this.row_model.note = null
    }

    get getBreadcrumbsPath() {
        return [
            {
                title: 'Progetto',
                name: 'DettaglioProgetto',
                params: {id: this.Sottoprogetto?.progetto_id || 0}
            },
            {
                title: 'Sottoprogetto',
                name: 'DettaglioSottoProgetto',
                params: {id: this.id || 0}
            },
            {
                title: 'Piano fatturazione',
            }
        ]
    }

    created() {
        this.pianoDiFatturazione.callBinds = [this.id]
        this.pianoDiFatturazione.reset()
        this.statoPianificazioneAutocomplete.search('', 0)

        sottoProgettiManager.sottoprogetto(this.id).then(async (res) => {
            this.numero_contratto = this.numero_contratto_model = res.data.pdf_numero_contratto
            this.data_contratto = this.data_contratto_model = res.data.pdf_data_contratto
            this.default_termine_pagamento_id = res.data.default_termine_pagamento_id
            await this.setSottoprogetto(res.data)
            return this.setDatiSottoprogetto(JSON.parse(res.data.ultimi_dati))
        }).then((res) => {
            return this.setValute(this.Sottoprogetto.ultimi_dati.valute)
        }).then((res) => {
            return progettiManager.progetto(this.Sottoprogetto.progetto_id)
        }).then((res) => {
            this.progetto = res.data
            this.default_cliente_id = res.data.cliente_id
            return clientiManager.cliente(this.progetto.cliente_id)
        }).then((res) => {
            this.cliente = res.data
        })

        sottoProgettiManager.gamma(this.id).then((res)=>{
            this.stato_gamma = res.data
        })

        sottoProgettiManager.versioni(this.id).then((res)=>{
            this.versioni = res.data.data
            let versione = this.versioni.find((v:any)=>v.version == this.Sottoprogetto.version)
            if(versione){
                this.versione = versione
            }
        })
    }

    async initSottoprogettoStore(sottoprogettoData:any){
        return this.setDatiSottoprogetto(JSON.parse(sottoprogettoData)).then((res:any) => {
            return this.setValute(sottoprogettoData.valute)
        }).then((res:any) => {
            return this.setValute(sottoprogettoData.valute)
        })
    }

    @Watch('versione')
    changeVersion($event:any){
        this.versione = $event
        this.initSottoprogettoStore($event.data)
    }

    righeCols: any[] = [
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Versione',
            prop: 'versione',
            orderable: false,
            class: 'text-left whitespace-nowrap w-36',
            td_class: 'h-8 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data emissione',
            prop: 'data_emissione_fattura',
            orderable: false,
            class: 'text-left whitespace-nowrap w-36',
            td_class: 'h-8 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Valore %',
            prop: 'valore_percentuale',
            orderable: false,
            class: 'text-left whitespace-nowrap w-24',
            td_class: 'h-8 px-2 text-right relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Valore €',
            prop: 'valore',
            orderable: false,
            class: 'text-left whitespace-nowrap w-24',
            td_class: 'h-8 px-2 text-right relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Cliente',
            prop: 'cliente_descrizione',
            orderable: false,
            class: 'text-left whitespace-nowrap w-80',
            td_class: 'h-8 px-2 text-left relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Descrizione',
            prop: 'descrizione',
            orderable: false,
            class: 'text-left whitespace-nowrap w-80',
            td_class: 'h-8 px-2 text-left relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Term. pag.',
            prop: 'termine_pagamento_descrizione',
            orderable: false,
            class: 'text-left w-32 whitespace-nowrap w-28',
            td_class: 'h-8 px-2 text-left relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'PO',
            prop: 'po',
            orderable: false,
            class: 'text-left w-32 whitespace-nowrap w-12',
            td_class: 'h-8 px-2 text-left relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Bef',
            prop: 'bef',
            orderable: false,
            class: 'text-left w-32 whitespace-nowrap w-12',
            td_class: 'h-8 px-2 text-left relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Stato',
            prop: 'conferma',
            orderable: false,
            class: 'text-left w-32 whitespace-nowrap',
            td_class: 'h-8 px-2 text-left relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Note',
            prop: 'note',
            orderable: false,
            class: 'text-left w-32 whitespace-nowrap w-80',
            td_class: 'h-8 px-2 text-left relative bg-next-gray-md-dark',
            resizable: false
        },
    ]
}


</script>


<style lang="scss">

</style>
